/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Emails from './Emails/index'
import Phones from './Phones/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content"
  
}) {
  return (<React.Fragment
>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
{children}
</React.Fragment>)
}